import DynamicFieldsFragment from '@linc-technologies/linced-common/models/dynamic-field/base-fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array, fragment } from 'ember-data-model-fragments/attributes';
import type BulkImportMedical from 'linced-app/models/people/bulk-import-medical';

// Proto: people.BulkImportMedicalContact.
export default class BulkImportMedicalContact extends DynamicFieldsFragment {
  declare [Type]: 'people/bulk-import-medical-contact';

  // priority determines the order in which contacts are displayed.
  @attr('number', { defaultValue: 0 })
  declare priority: number;

  // relationship is the type of relationship of the contact with respect to
  // the person.
  @attr('number', { defaultValue: 0 })
  declare relationship: number;

  // startDate is the date from which this medical contact applies.
  @attr('string')
  declare startDate: string | undefined;

  // endDate is the date until which this medical contact applies.
  @attr('string')
  declare endDate: string | undefined;

  // permissionToContact specifies whether the school can contact this person.
  @attr('boolean', { defaultValue: false })
  declare permissionToContact: boolean;

  // Notes regarding the contact.
  @attr('string', { defaultValue: '' })
  declare notes: string;

  // propsToImport specifies which of the above properties to import.
  // This is to work around the ambiguity of the empty value (are we
  // importing an empty value, or do we want to leave it unchanged?).
  @array('number')
  declare propsToImport: StatefulArray<number>;

  // medical specifies the details of the Medical Specialist who this Contact
  // record relates to.
  @fragment('people/bulk-import-medical')
  declare medical: BulkImportMedical | null;
  // dynamic fields to do with the relationship (rather than the caregiver).
  // `relationshipFields` is handled by the DynamicFields serializer (it
  // maps the dynamic fields to/from `relationshipFields`).
}
